module.exports = __webpack_public_path__ + "assets/img/drop.1ccf2049.svg";